<template>
  <Loading v-if="!fullyLoaded" />
  <AllocationUnitForm v-else :sites="sites" :submit="submit" :cancel="cancel" />
</template>

<script>
import CreateView from '@/mixins/createView';
import ResourceService from '@/services/resources/allocation_units_service';
import SiteService from '@/services/resources/sites_service';

export default {
  mixins: [CreateView],
  components: {
    AllocationUnitForm: () => import('@/components/forms/AllocationUnitForm.vue'),
  },
  data() {
    return {
      urlFragment: 'allocation-units',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    sites: {
      get() {
        if (this.siteId) {
          return SiteService.get(this.siteId).then((site) => {
            return [site.data];
          });
        }

        return SiteService.index().then((sites) => {
          return sites.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
};
</script>
